import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconOrientationBoxes12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconOrientationBoxes12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#OrientationBoxes12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M1.5 1h4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5m.5 9h-.5A1.5 1.5 0 0 1 0 8.5v-7A1.5 1.5 0 0 1 1.5 0h4A1.5 1.5 0 0 1 7 1.5V5h3.5A1.5 1.5 0 0 1 12 6.5v4a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 2 10.5zm1 0v.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5H7v2.5A1.5 1.5 0 0 1 5.5 10z"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="OrientationBoxes12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconOrientationBoxes12);
